import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Customer } from 'src/app/interfaces/customer';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuditService } from 'src/app/services/audit.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfigDataService } from 'src/app/services/config-data.service';
import { GeneralService } from 'src/app/services/general.service';
import { TranslatorService } from 'src/app/services/translator.service';

@Component({
    selector: 'app-mvr-by-state',
    templateUrl: './mvr-by-state.component.html',
    styleUrl: './mvr-by-state.component.scss',
    standalone: false
})
export class MvrByStateComponent {
    userProfile?: UserProfile;
    customer?: Customer = {};
    isLoading = false;
    username: string = '';
    companyType: string = '';
    showMVRByState: boolean = false;
    isDriver = false;

    constructor(private generalService: GeneralService,
        private router: Router,
        private authenticationService: AuthenticationService,
        private auditService: AuditService,
        private translatorService: TranslatorService,
        private configDataService: ConfigDataService,
        private modalService: NgbModal) { }

    ngOnInit(): void {
        window.onbeforeunload = null;
        this.isLoading = true;
        this.username = this.authenticationService.getUserName();
        this.userProfile = this.authenticationService.getUserProfile();
        this.customer = this.userProfile!.customer;

        this.configDataService.getConfig('showMVRByState').then((value: any) => {
            if (value && value.toString().toLowerCase() === 'true') {
                this.showMVRByState = true;
            }else{
                this.showMVRByState = false;
                this.router.navigateByUrl('/accessDenied');
            }
        }).catch((error: any) => {
           this.generalService.pageLogging("MRV", null, "", "Error: finding Config Key 'showMVRByState'. " + error, "");
        });

        this.companyType = '';
        if (this.customer && this.customer.customerType === 6)
        {
            this.companyType = 'ISP';
        } else if (this.customer) {
            this.companyType = 'MC';
        } else {
            this.isDriver = true;
        }

      this.scrollToTop();
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    } 
  
    openDocument(docName: string) {
        this.generalService.openDocument(docName);
    }
}
